import type { WidgetConfig } from '@digital-cs/shared';
import type { ImStatus } from '../../services/vocechat-client';
import { currentLocale } from '../../store/widget-store';
import { pickCsMessage } from '../../i18n/widget-content';
import { IconBot, IconUser, IconWeChat, PlaceholderQR } from '../web/icons';

/**
 * 人工离线友好卡片 —— 转人工时检测到坐席不在线时展示:离线提示 + 微信二维码 + 服务时间 + 返回 AI。
 * 从 WebChatPanel 抽出,web 客服与数字人客服共用(复用 dcs-web-offline-* 样式)。
 * 数据优先取 IM 下发的离线引导(imOffline),缺省回退客服后台配置(cfg.wechatQrUrl / cfg.workTime)。
 */
export function OfflineCard({
  cfg,
  imOffline,
  onBackToAi,
  t,
}: {
  cfg: WidgetConfig;
  imOffline: ImStatus['offline'] | null;
  onBackToAi: () => void;
  t: (key: string) => string;
}) {
  const qrUrl = imOffline?.qrUrl || cfg.wechatQrUrl;
  const serviceHours =
    imOffline?.serviceHours || pickCsMessage(cfg, 'workTime', currentLocale.value);
  return (
    <div class="dcs-web-offline-wrap">
      <div class="dcs-web-offline-card">
        <div class="dcs-web-offline-head">
          <div class="dcs-web-offline-icon">
            <IconUser size={22} />
          </div>
          <div class="dcs-web-offline-text">
            <h3>{t('web.agentOffline')}</h3>
            <p>{imOffline?.guideText || t('web.agentOfflineMessage')}</p>
          </div>
        </div>
        <div class="dcs-web-offline-qrwrap">
          <div class="dcs-web-offline-pill">
            <IconWeChat size={14} />
            <span>{t('web.wechatPrompt')}</span>
          </div>
          <div class="dcs-web-qrframe">
            {qrUrl ? (
              <img
                src={qrUrl}
                alt=""
                width={160}
                height={160}
                style={{ width: 160, height: 160, objectFit: 'contain' }}
              />
            ) : (
              <PlaceholderQR size={160} />
            )}
            <span class="dcs-web-qr-corner is-tl" aria-hidden="true" />
            <span class="dcs-web-qr-corner is-tr" aria-hidden="true" />
            <span class="dcs-web-qr-corner is-bl" aria-hidden="true" />
            <span class="dcs-web-qr-corner is-br" aria-hidden="true" />
          </div>
          <p class="dcs-web-qr-hint">{t('web.wechatHint')}</p>
          {serviceHours && (
            <p class="dcs-web-qr-hint">
              {t('web.serviceHoursLabel')}
              {serviceHours}
            </p>
          )}
        </div>
        <div class="dcs-web-offline-foot">
          <button type="button" class="dcs-web-back-btn" onClick={onBackToAi}>
            <IconBot size={16} />
            <span>{t('web.switchToAI')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
